<div [formGroup]="form" class="row g-3">
    <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
            <mat-label>CST IS</mat-label>
            <input matInput type="text" formControlName="cstIs">
        </mat-form-field>
    </div>
    <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
            <mat-label>cClassTrib IS</mat-label>
            <input matInput type="text" formControlName="cclassTribIs">
        </mat-form-field>
    </div>
    <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
            <mat-label>Alíquota IS (%)</mat-label>
            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pIs">
        </mat-form-field>
    </div>
    <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
            <mat-label>Alíquota Ad Rem</mat-label>
            <input matInput type="text" inputmode="numeric" [currencyMask]="currencyMask" formControlName="adRemIs">
        </mat-form-field>
    </div>
</div>
